var exports = {
  "Sc": "UserArea.module__userAreaInnerWrapper___V3VQVW",
  "cU": "UserArea.module__userAreaContainer___V3VQVW",
  "jC": "UserArea.module__popoutContainer___V3VQVW",
  "oT": "UserArea.module__voiceConnectionWrapper___V3VQVW",
  "eF": "UserArea.module__userInfo___V3VQVW",
  "vu": "UserArea.module__active___V3VQVW",
  "N6": "UserArea.module__userInfoText___V3VQVW",
  "nT": "UserArea.module__userName___V3VQVW",
  "ag": "UserArea.module__userStatus___V3VQVW",
  "uh": "UserArea.module__userStatusLabel___V3VQVW" + " " + "UserArea.module__userStatus___V3VQVW",
  "XW": "UserArea.module__userCustomStatus___V3VQVW" + " " + "UserArea.module__userStatus___V3VQVW",
  "oM": "UserArea.module__hoverRoll___V3VQVW",
  "n6": "UserArea.module__defaultState___V3VQVW",
  "yo": "UserArea.module__hovered___V3VQVW",
  "EE": "UserArea.module__forceHover___V3VQVW",
  "gO": "UserArea.module__controlsContainer___V3VQVW",
  "uH": "UserArea.module__controlButton___V3VQVW",
  "DY": "UserArea.module__contextMenuHover___V3VQVW",
  "r9": "UserArea.module__disabled___V3VQVW",
  "pd": "UserArea.module__controlIcon___V3VQVW",
  "se": "UserArea.module__controlIconWithDot___V3VQVW",
  "PP": "UserArea.module__controlDot___V3VQVW",
};

module.exports = exports;
